module.exports = __webpack_public_path__ + "img/expodecor_wooden_floor.72288bee.jpg";